import { useEffect, useState } from "react"
import { Alert, Button, Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap"
import Template from "../../../layout/Template"
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from "zod"
import { EmpresasService } from "../../../services/api/Empresas/EmpresasService"
import { useNavigate, useParams } from "react-router-dom"
import { limpaTelefone, limpaCpf } from "../../../utils/Funcoes"
import { Commons } from "../../../utils/Commons"
import { useHookFormMask } from 'use-mask-input';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Loading from "../../../components/Loader/Loading"
import ConfiguracoesSistemaPrincipal from "../ConfiguracoesSistemaPrincipal"
import { usePermissoes } from "../../../hooks/usePermissoes"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"


const scheme = z.object({
    tiposPessoasId: z.string(),
    nome: z.string(),
    razaoSocial: z.string().nullable(),
    cpf: z.coerce.string().nullable(),
    email: z.union([
        z.literal(''),
        z.literal(null),
        z.string().email('E-mail inválido')
    ]),
    telefone: z.coerce.string().nullable(),
    celular: z.coerce.string().nullable(),
    cep: z.coerce.string().nullable(),
    logradouro: z.string().nullable(),
    numero: z.coerce.string().nullable(),
    complemento: z.string().nullable(),
    bairro: z.string().nullable(),
    cidade: z.string().nullable(),
    uf: z.string().nullable(),
    abertura: z.coerce.string().nullable(),
    fechamento: z.coerce.string().nullable(),
    intervaloAgendaHosp: z.coerce.string().nullable(),
    facebook: z.coerce.string().nullable(),
    instagram: z.coerce.string().nullable(),
    logo: z.any().nullable(),
}).refine((data) => { return !(data.tiposPessoasId.toString() === '1' && data.nome == '') }, {
    message: "O Nome é obrigatório",
    path: ["nome"], // path of error
}).refine((data) => { return !(data.tiposPessoasId.toString() === '2' && data.razaoSocial == '') }, {
    message: "A Razão Social é obrigatória",
    path: ["razaoSocial"], // path of error
})

const EmpresasCadEdit = () => {
    const navigate = useNavigate()
    const { idEmpresa } = useParams();
    const [empresa, setEmpresa] = useState(null)
    const { register, handleSubmit, watch, formState: { errors } } = useForm({
        mode: 'onBlur',
        resolver: zodResolver(scheme),
        values: empresa
    })
    const registerWithMask = useHookFormMask(register);


    const [showAnimais, setShowAnimais] = useState(false)
    const [keyTab, setKeyTab] = useState('dadosPessoais')
    const [isPessoaJuridica, setIsPessoaJuridica] = useState(false)
    const watchShowJuridica = watch('tiposPessoasId')
    const [alert, setAlert] = useState({ tipo: null, msg: null, show: false })

    const [disableSalvar, setDisableSalvar] = useState(false)
    const [isLoading, setIsloading] = useState(true)
    const [isPermitido, setIsPermitido] = useState([])
    const { listPermissoes } = usePermissoes([
        { secoesId: 8, acoesId: 1 },
        { secoesId: 8, acoesId: 2 },
        { secoesId: 8, acoesId: 3 },
    ])

    const watchFoto = watch('logo')
    const [imgFoto, setImgFoto] = useState(null)

    useEffect(() => {

        console.log(watchFoto)
        if (watchFoto != undefined) {

            if (watchFoto.length > 0) {
               
             //   const teste = URL.createObjectURL(watchFoto[0])
              //    setImgFoto(teste)
            }

        }
    }, [watchFoto])

    const onSubmit = async (data) => {
        setDisableSalvar(true)


        let formData = new FormData();
        formData.append('abertura', (data.abertura != null) ? (data.abertura) : '')
        formData.append('bairro', (data.bairro != null) ? (data.bairro) : '')
        formData.append('cidade', (data.cidade != null) ? (data.cidade) : '')
        formData.append('complemento', (data.complemento != null) ? (data.complemento) : '')
        formData.append('email', (data.email != null) ? data.email : '')
        formData.append('facebook', (data.facebook != null) ? (data.facebook) : '')
        formData.append('fechamento', (data.fechamento != null) ? (data.fechamento) : '')
        formData.append('instagram', (data.instagram != null) ? (data.instagram) : '')
        formData.append('intervaloAgendaHosp', (data.intervaloAgendaHosp != null) ? (data.intervaloAgendaHosp) : '')
        formData.append('logradouro', (data.logradouro != null) ? (data.logradouro) : '')
        formData.append('nome', (data.nome != null) ? (data.nome) : '')
        formData.append('numero', (data.numero != null) ? (data.numero) : '')
        formData.append('razaoSocial', (data.razaoSocial != null) ? (data.razaoSocial) : '')
        formData.append('uf', (data.uf != null) ? (data.uf) : '')
        formData.append('telefone', (data.telefone != null) ? limpaTelefone(data.telefone) : '')
        formData.append('celular', (data.celular != null) ? limpaTelefone(data.celular) : '')
        formData.append('cpf', (data.cpf != null) ? limpaCpf(data.cpf) : '')
        formData.append('cep', (data.cep != null) ? limpaCpf(data.cep) : '')


        if (data.logo != null) {
            formData.append("logo", data.logo[0]);
        }

     
        if (idEmpresa != undefined) {
            const res = await EmpresasService.store(formData)

            setDisableSalvar(false)
            if (res.success) {
                navigate('/admin/configuracoes/empresas')

                setAlert(...alert, { tipo: 'success', msg: 'Salvo com sucesso!', show: true })
            } else {
                alert(res.msg)

            }


        } else {
            const res = await EmpresasService.store(formData)
            setDisableSalvar(false)
            if (res.success) {
                navigate('/admin/configuracoes/empresas')
                setAlert({ tipo: 'success', msg: 'Salvo com sucesso!', show: true })

                setTimeout(function () {
                    setAlert({ ...alert, show: false })


                }, 3000)
            }
        }

    }



    useEffect(() => {

        //if (idEmpresa != undefined) {
        const fetchData = async () => {
            setIsloading(true);
            const data = await EmpresasService.getAll()
            const cli = data.data[0]
            setEmpresa({
                ...cli,
                tiposPessoasId: (cli?.tipos_pessoas?.id) ? cli?.tipos_pessoas?.id.toString() : '',
                uf: (cli?.ufs?.sigla) ? cli?.ufs?.sigla : ''
            })
            if (cli?.logo != '') {
                setImgFoto(cli.logo)
            }
            setIsloading(false);
        }
        fetchData()



        setShowAnimais(true)




        /* } else {
             setEmpresa({
                 ...empresa,
                 tiposPessoasId: '1'
             })
         }*/

    }, [])



    useEffect(() => {
        if (watchShowJuridica == 2) {
            setIsPessoaJuridica(true)
        } else {
            setIsPessoaJuridica(false)
        }

        //console.log(watchShowJuridica)
    }, [watchShowJuridica])

 
    return (

        <ConfiguracoesSistemaPrincipal>
            <>



                <h3><span className="text-primary">Empresa </span> </h3>
                <h5 className="text-primary"></h5>
                <hr></hr>

                {(isLoading) ? <Loading /> : (
                    <>
                        <div style={{ maxWidth: '800px' }}>


                            <Form>
                                <br></br>
                                <h5 className="text-primary">Logomarca </h5>
                                <Row>
                                    <Form.Group as={Col} sm={5} >
                                        <img src={imgFoto} style={{ maxWidth: '150px' }} />
                                    </Form.Group>
                                </Row>
                                <Row >
                                    <Form.Group as={Col} sm={4}>
                                        <Form.Label>Inserir/Alterar logomarca:</Form.Label>
                                        <Form.Control type="file" accept="image/png, image/gif, image/jpeg"
                                            {...register('logo')}
                                        ></Form.Control>

                                    </Form.Group>

                                </Row>


                                <hr></hr>


                                <Row>
                                    <Form.Group >
                                        <Form.Label>Tipo de Pessoa:</Form.Label><br />
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="Pessoa Física"
                                            value="1"

                                            {...register('tiposPessoasId')}
                                        ></Form.Check>
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="Pessoa Jurídica"
                                            value="2"
                                            {...register('tiposPessoasId')}></Form.Check>
                                    </Form.Group>
                                </Row>

                                <div className="divPessoaJuridica" style={{ display: (isPessoaJuridica) ? '' : 'none' }}>
                                    <Row >
                                        <Form.Group as={Col} controlId="formRazaoSocial">
                                            <Form.Label>Razão Social</Form.Label>
                                            <Form.Control type="text" placeholder="Razão Social"
                                                {...register('razaoSocial')}
                                                isInvalid={!!(errors?.razaoSocial)}
                                            ></Form.Control>
                                        </Form.Group>
                                        <Form.Control.Feedback type='invalid' >
                                            {errors?.razaoSocial?.message}
                                        </Form.Control.Feedback>

                                    </Row>
                                    <Row >
                                        <Form.Group as={Col} controlId="formNomeFantasia" xs={8}>
                                            <Form.Label>Nome Fantasia</Form.Label>
                                            <Form.Control type="text" placeholder="Nome Fantasia"
                                                isInvalid={false}
                                                {...register('nomeFantasia')}
                                            ></Form.Control>
                                            <Form.Control.Feedback type="invalid">

                                            </Form.Control.Feedback>

                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formCnpj" xs={4} >
                                            <Form.Label>CNPJ:</Form.Label>
                                            <Form.Control type="text" placeholder="CNPJ"
                                                {...register('cnpj')}
                                            ></Form.Control>
                                        </Form.Group>
                                    </Row>


                                </div>

                                <div className="divPessoaFisica" style={{ display: (!isPessoaJuridica) ? '' : 'none' }}>

                                    <Row className="lg-5" >
                                        <Form.Group as={Col} controlId="formNome" xs={6}>
                                            <Form.Label>Nome*</Form.Label>
                                            <Form.Control type="text" placeholder="Nome"
                                                {...register('nome')}
                                                isInvalid={!!errors?.nome}
                                            />
                                            <Form.Control.Feedback type='invalid'>
                                                {errors?.nome?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                    </Row>
                                    <Row >
                                        <Form.Group as={Col} md={4} controlId="formCpf">
                                            <Form.Label>CPF:</Form.Label>
                                            <Form.Control type="text" placeholder="CPF"
                                                {...register('cpf')}
                                                {...registerWithMask('cpf', ['999.999.999-99'])} />
                                        </Form.Group>

                                    </Row>
                                </div>
                                <Row>
                                    <Form.Group as={Col} controlId="formEmail" xs={12} md={4}>
                                        <Form.Label>E-mail</Form.Label>
                                        <Form.Control type="text" placeholder="E-mail" isInvalid={!!errors?.email}
                                            {...register('email')} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors?.email?.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formTelefone" className="align-self-start">
                                        <Form.Label>Telefone</Form.Label>
                                        <Form.Control type="text" placeholder="Telefone"

                                            {...registerWithMask('telefone', ['(99) 9999-9999'])}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formCelular">
                                        <Form.Label>Celular</Form.Label>
                                        <Form.Control type="text" placeholder="Celular"
                                            {...registerWithMask('celular', ['(99) 99999-9999'])}
                                            isInvalid={!!errors?.nome}
                                        ></Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors?.celular?.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>
                                <hr></hr>
                                <Row>
                                    <Form.Group as={Col} md={4} controlId="formCep">
                                        <Form.Label>CEP</Form.Label>
                                        <Form.Control type="text" placeholder="CEP"
                                            {...registerWithMask('cep', ['99999-999'])}></Form.Control>
                                    </Form.Group>
                                </Row>
                                <Row>
                                    <Form.Group as={Col} controlId="formLogradouro">
                                        <Form.Label>Logradouro</Form.Label>
                                        <Form.Control type="text" placeholder="Logradouro"
                                            {...register('logradouro')} />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formLNumero" md={2}>
                                        <Form.Label>Número</Form.Label>
                                        <Form.Control type="text" placeholder="Numero"
                                            {...register('numero')}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formComplemento">
                                        <Form.Label>Complemento</Form.Label>
                                        <Form.Control type="text" placeholder="Complemento"
                                            {...register('complemento')} />
                                    </Form.Group>
                                </Row>
                                <Row>
                                    <Form.Group as={Col} controlId="formBairro">
                                        <Form.Label>Bairro</Form.Label>
                                        <Form.Control type="text" placeholder="Bairro"
                                            {...register('bairro')}></Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formCidade">
                                        <Form.Label>Cidade</Form.Label>
                                        <Form.Control type="text" placeholder="Cidade"
                                            {...register('cidade')}></Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formUf">
                                        <Form.Label>UF</Form.Label>
                                        <Form.Select type="text" placeholder="UF"
                                            {...register('uf')} >
                                            {Commons.getOptionsUF().map((item, key) => (
                                                <option value={item.sigla} key={key}>{item.sigla} - {item.nome} </option>

                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Row>
                                <hr></hr>
                                <h5 className="text-primary">Redes Sociais </h5>
                                <Row>
                                    <Form.Group as={Col} controlId="formFacebook">
                                        <Form.Label>Facebook</Form.Label>
                                        <Form.Control type="text" placeholder="Facebook"
                                            {...register('facebook')}></Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formInstagram">
                                        <Form.Label>Instagram</Form.Label>
                                        <Form.Control type="text" placeholder="Instagram"
                                            {...register('instagram')}></Form.Control>
                                    </Form.Group>
                                </Row>

                                <hr></hr>
                                <h5 className="text-primary">Dados de funcionamento </h5>
                                <small >Funciona também para  agendas que não tenham vínculo com um profissional </small>
                                <br>
                                </br>
                                <br>
                                </br>
                                <Row>
                                    <Form.Group as={Col} controlId="formAbertura">
                                        <Form.Label>Hora de Abertura</Form.Label>
                                        <Form.Control type="time" placeholder="Hora de Abertura"
                                            {...register('abertura')}></Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="formFechamento">
                                        <Form.Label>Hora de fechamento</Form.Label>
                                        <Form.Control type="time" placeholder="Fechamento"
                                            {...register('fechamento')}></Form.Control>
                                    </Form.Group>
                                </Row>
                                <Row className="mt-10">
                                    <Form.Group as={Col} sm={4} controlId="formIntervaloAgendaHosp">
                                        <Form.Label>Intervalo da agenda(minutos)</Form.Label>
                                        <Form.Control type="number" placeholder="Intervalo"
                                            {...register('intervaloAgendaHosp')}></Form.Control>
                                    </Form.Group>

                                </Row>





                                <br></br>
                                <Alert variant={alert?.tipo} show={alert?.show} className="text-center">
                                    {alert?.msg}

                                </Alert>




                                <div className="text-center "  >
                                    {(listPermissoes?.cadastrar) ?
                                        <Button variant="primary"
                                            size="sm" onClick={() => handleSubmit(onSubmit)()}>
                                            {(disableSalvar) ? <>
                                                <FontAwesomeIcon icon={faSpinner} spin /> Salvando...
                                            </> : 'Salvar'}</Button> : ''}




                                </div>

                            </Form>
                        </div>
                    </>)}

            </>

        </ConfiguracoesSistemaPrincipal >
    )
}
export default EmpresasCadEdit